import type { ComponentProps } from 'react';

import { cn } from '@/shared/lib/cn';

export function Kbd({ className, ...props }: ComponentProps<'kbd'>) {
  return (
    <kbd
      data-slot="kbd"
      className={cn(
        'pointer-events-none inline-flex h-5 min-w-5 items-center justify-center gap-0.5 rounded-xs border border-border bg-muted px-1 font-sans text-[0.6875rem] font-medium text-muted-foreground select-none',
        className,
      )}
      {...props}
    />
  );
}
